import { createFileRoute, redirect } from "@tanstack/react-router"

import { getProductCostsTabRoute } from "@/screens/Products/components/Product/Costs"

export const PRODUCT_COSTS_INDEX_ROUTE_PATH = "/app/product/$productId/edit/_layout/costs/"

export const Route = createFileRoute(PRODUCT_COSTS_INDEX_ROUTE_PATH)({
  beforeLoad: async ({ params }) => {
    return redirect({ to: getProductCostsTabRoute(params.productId) })
  },
})
